import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { map, find, filter, reduce } from 'ramda';
import { ISubAttributeMain } from '../../../../common/models/attribute/ISubAttributeMain';
import { IAttribute } from '../../../../common/models/attribute/IAttribute';
import { IQuestion } from '../../../../common/models/question/IQuestion';
import { getAttributeColors } from '../../../../common/helpers/colorHelper';
import styles from './styles.module.scss';

interface IProps {
  attribute: string;
  selectedQuestions: IQuestion[];
  attributes: IAttribute[];
}

const AttributePopupBody: FunctionComponent<IProps> = ({
  attribute,
  attributes,
  selectedQuestions
}) => {
  const attributeInfo = find(({ name }) => attribute === name, attributes) as IAttribute;
  const counters = reduce((acc, subAttribute) => ({
    ...acc,
    [subAttribute.id]: filter(
      question => question.subAttribute?.id === subAttribute.id,
      selectedQuestions
    ).length
  }), {}, attributeInfo.subAttributes) as Record<string, number>;

  const SubAttributeCounter = ({ subAttribute }: { subAttribute: ISubAttributeMain }) => {
    const value = counters[subAttribute.id];

    return (
      <div className={styles.subAttributeCounter}>
        <span>{subAttribute.name}</span>
        <div className={styles.counterCircle} style={value ? getAttributeColors(attribute) : undefined}>
          {value}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.attributePopup}>
      <div className={styles.popupTitle}>
        <FormattedMessage id="ratingScale.popupTitle" defaultMessage="Questions per competency" />
      </div>
      <div className={styles.countersContainer}>
        {map(subAttribute => (
          <SubAttributeCounter
            key={subAttribute.id}
            subAttribute={subAttribute}
          />
        ), attributeInfo.subAttributes)}
      </div>
    </div>
  );
};

export default AttributePopupBody;
